import { render, staticRenderFns } from "./confirm-presentation-reorder.vue?vue&type=template&id=3b2fc61e&scoped=true&"
import script from "./confirm-presentation-reorder.vue?vue&type=script&lang=js&"
export * from "./confirm-presentation-reorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2fc61e",
  null
  
)

export default component.exports